import { AppState } from '../types';

export const appStateDefaults: AppState = {
  title: 'CS Frontend',
};
